import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

export type UserMfaResetPayload = UserPayload;

export type UserMfaResetAction = {
	type: 'USER_MFA_RESET';
	payload: UserMfaResetPayload;
	accountId: number;
};

export default (payload: UserMfaResetPayload, accountId: number): UserMfaResetAction => ({
	type: 'USER_MFA_RESET',
	payload,
	accountId,
});
